module.exports = __webpack_public_path__ + "img/reseau-environnement-blanc.f5347eef.png";